import storage from "./storage.js";

/**
 *
 * StoreFrontSponsorStorageService
 *
 * @namespace StoreFrontSponsorStorageService
 */
"use strict";

var STORAGE_KEY = storage.metadata.STOREFRONT;

// ---------------------------------------------
//
//            Define public methods
//
// ---------------------------------------------
var publicMethods = {
    clearStoreFrontSponsor: function () {
        publicMethods.setStoreFrontSponsor(null);
    },
    getStoreFrontSponsor: function () {
        return storage.getItem(STORAGE_KEY);
    },
    setStoreFrontSponsor: function (sponsor) {
        if (sponsor == null || typeof (sponsor) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else {
            storage.setItem(STORAGE_KEY, sponsor);
        }
    },
    isStorefront: function () {
        var storefront = publicMethods.getStoreFrontSponsor();
        return storefront !== null && storefront !== undefined;
    }
};

export default publicMethods;

